import React from 'react';
import './About.css';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        <div className="about-header">
          <h1 className="about-title">À Propos de Prosperian</h1>
          <p className="about-intro">
            Découvrez qui nous sommes et pourquoi nous transformons la prospection B2B
          </p>
        </div>

        <div className="about-content">
          <div className="about-block">
            <h2 className="block-title">Pourquoi Prosperian</h2>
            <div className="block-content">
              <p>
                Prosperian est né d'un constat simple : alors que le monde de la vente B2B se transforme radicalement, la plupart des approches de prospection restent figées dans des modèles obsolètes.
              </p>
              <p>
                Notre nom symbolise notre mission : allier PROspection intelligente et expERIence client exceptionnelle pour générer une véritable prospÉRIté commerciale. Nous sommes PROactifs, PROches de nos clients et résolument PROFessionnels dans notre démarche.
              </p>
              <p>
                En créant Prosperian, nous avons voulu réconcilier technologie de pointe et expertise humaine pour offrir une solution qui répond aux véritables enjeux des entreprises B2B : non pas simplement générer plus de leads, mais générer les bons leads et les convertir efficacement.
              </p>
            </div>
          </div>

          <div className="about-block">
            <h2 className="block-title">Qui nous sommes</h2>
            <div className="block-content">
              <p>
                Prosperian est un collectif de talents experts unis par une même passion : révolutionner la prospection B2B.
              </p>
              <p>
                Notre équipe réunit des spécialistes chevronnés dans chaque domaine clé de l'acquisition client : stratégistes LinkedIn, copywriters, experts en marketing automation, data analysts, spécialistes de webinaires et consultants en sales enablement.
              </p>
              <p>
                Ce qui nous distingue ? Notre approche collaborative qui permet à chaque client de bénéficier de l'expertise pointue de chaque membre du collectif, orchestrée par un attaché de compte dédié qui assure cohérence et efficacité.
              </p>
              <p>
                Nous ne sommes pas des théoriciens du marketing, mais des praticiens obsédés par les résultats mesurables. Notre succès se mesure uniquement à l'aune du vôtre : plus d'opportunités qualifiées, des cycles de vente raccourcis et un ROI démontrable.
              </p>
              <p>
                En choisissant Prosperian, vous n'engagez pas simplement un prestataire, vous rejoignez un écosystème d'excellence qui propulse votre prospection commerciale vers de nouveaux sommets.
              </p>
            </div>
          </div>

          <div className="about-block">
            <h2 className="block-title">Notre Collectif d'Expertises</h2>
            <div className="block-content">
              <div className="expertise-grid">
                <div className="expertise-card">
                  <div className="expertise-content">
                    <h3 className="expertise-title">STRATÉGIE & CONSEIL COMMERCIAL</h3>
                    <ul className="expertise-list">
                      <li>Audit de processus de vente (CRM, tunnel, conversion)</li>
                      <li>Structuration des équipes commerciales</li>
                      <li>Définition de personas & ICP (Ideal Customer Profile)</li>
                      <li>Développement de playbooks de vente</li>
                      <li>Sales Enablement (outils, scripts, ressources)</li>
                    </ul>
                  </div>
                </div>

                <div className="expertise-card">
                  <div className="expertise-content">
                    <h3 className="expertise-title">PROSPECTION MULTICANALE</h3>
                    <ul className="expertise-list">
                      <li>Cold Emailing (copywriting, paramétrage, délivrabilité)</li>
                      <li>Cold Calling (scripts, objection handling, formation SDR)</li>
                      <li>LinkedIn Prospecting (outreach manuel ou automatisé)</li>
                      <li>Publicité B2B (LinkedIn Ads, Meta, Google Ads)</li>
                      <li>ABM (Account-Based Marketing) pour les cibles stratégiques</li>
                    </ul>
                  </div>
                </div>

                <div className="expertise-card">
                  <div className="expertise-content">
                    <h3 className="expertise-title">COPYWRITING & CREATIVITÉ</h3>
                    <ul className="expertise-list">
                      <li>Création de séquences multicanales personnalisées</li>
                      <li>Copywriting orienté conversion (emails, pages de vente, Ads)</li>
                      <li>Storytelling commercial B2B</li>
                      <li>Création d'angles différenciants</li>
                    </ul>
                  </div>
                </div>

                <div className="expertise-card">
                  <div className="expertise-content">
                    <h3 className="expertise-title">TECH & AUTOMATION</h3>
                    <ul className="expertise-list">
                      <li>Paramétrage de CRM (HubSpot, Pipedrive, etc.)</li>
                      <li>Automatisation des campagnes (Zapier, Make, n8n)</li>
                      <li>Data Enrichment & Scraping</li>
                      <li>Qualification et segmentation de base de données</li>
                      <li>A/B Testing & itérations sur les séquences</li>
                    </ul>
                  </div>
                </div>

                <div className="expertise-card">
                  <div className="expertise-content">
                    <h3 className="expertise-title">IA & DATA</h3>
                    <ul className="expertise-list">
                      <li>Utilisation d'agents IA pour :</li>
                      <li className="sub-item">Répondre automatiquement aux leads</li>
                      <li className="sub-item">Qualifier des prospects</li>
                      <li className="sub-item">Relancer automatiquement</li>
                      <li>Intégration d'IA dans les processus de prospection</li>
                      <li>Analyse de données de campagnes (KPI, ROI, taux de transfo)</li>
                      <li>Développement d'algorithmes internes comme le "Prosperian Score"</li>
                    </ul>
                  </div>
                </div>

                <div className="expertise-card">
                  <div className="expertise-content">
                    <h3 className="expertise-title">DESIGN & CONVERSION</h3>
                    <ul className="expertise-list">
                      <li>Création de landing pages optimisées</li>
                      <li>UX/UI orientée conversion</li>
                      <li>CRO (Conversion Rate Optimization)</li>
                    </ul>
                  </div>
                </div>

                <div className="expertise-card">
                  <div className="expertise-content">
                    <h3 className="expertise-title">FORMATION & ACCOMPAGNEMENT</h3>
                    <ul className="expertise-list">
                      <li>Formation des équipes internes à l'outbound</li>
                      <li>Support & coaching en continu (sales coaching)</li>
                      <li>Documentation et onboarding client</li>
                    </ul>
                  </div>
                </div>

                <div className="expertise-card">
                  <div className="expertise-content">
                    <h3 className="expertise-title">GESTION DE PROJET</h3>
                    <ul className="expertise-list">
                      <li>Pilotage multi-agences ou multi-campagnes</li>
                      <li>Suivi des deadlines et livrables</li>
                      <li>Mise à disposition de dashboards clairs</li>
                      <li>Communication fluide entre consultants et clients</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="about-cta">
        <div className="about-container">
          <h2 className="cta-title">DÉCOUVREZ VOTRE POTENTIEL DE CROISSANCE</h2>
          <p className="cta-description">
            Rejoignez les entreprises qui ont déjà transformé leur approche commerciale avec Prosperian.
          </p>
          <a href="https://www.videoask.com/fd8vz299c" target="_blank" rel="noopener noreferrer">
            <button className="cta-button">TESTEZ VOTRE ÉLIGIBILITÉ</button>
          </a>
        </div>
      </div>

      <div className="about-cta secondary">
        <div className="about-container">
          <h2 className="cta-title">Prêt à accélérer votre croissance ?</h2>
          <p className="cta-description">
            Découvrez comment notre méthodologie peut s'adapter à vos enjeux spécifiques.
          </p>
          <div className="cta-buttons">
            <a href="https://calendly.com/cb-prosperian/presentation-prosperian" target="_blank" rel="noopener noreferrer">
              <button className="cta-button">Demander une démo</button>
            </a>
            <a href="https://www.videoask.com/fd8vz299c" target="_blank" rel="noopener noreferrer">
              <button className="cta-button secondary">Tester mon éligibilité</button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 